const STEMEnrollmentData = [
  {
    year: '2012-13',
    EECS: 1177.5,
    POLSCI: 937,
    ECON: 900.5,
    PSYCH: 701.5,
    INTEGBI: 627.5,
    UGBA: 655.5,
    ENGLISH: 614,
    MECENG: 578,
    SOCIOL: 464,
    ARCH: 454.5,
    COMPSCI: null,
    MEDIAST: null,
    MATH: null,
    COGSCI: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2013-14',
    EECS: 1236.5,
    ECON: 1029,
    POLSCI: 881,
    INTEGBI: 686,
    UGBA: 678,
    PSYCH: 668,
    MECENG: 600,
    COMPSCI: 572,
    ENGLISH: 528,
    SOCIOL: 448.5,
    ARCH: null,
    MEDIAST: null,
    MATH: null,
    COGSCI: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2014-15',
    EECS: 1205,
    ECON: 1056,
    COMPSCI: 832.5,
    POLSCI: 815,
    PSYCH: 684,
    UGBA: 668,
    MECENG: 618.5,
    INTEGBI: 600,
    ENGLISH: 489.5,
    SOCIOL: 486.5,
    ARCH: null,
    MEDIAST: null,
    MATH: null,
    COGSCI: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2015-16',
    EECS: 1245.5,
    ECON: 1073,
    COMPSCI: 994.5,
    POLSCI: 816.5,
    UGBA: 699.5,
    PSYCH: 625.5,
    MECENG: 604.5,
    ENGLISH: 506.5,
    SOCIOL: 487,
    INTEGBI: 447,
    ARCH: null,
    MEDIAST: null,
    MATH: null,
    COGSCI: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2016-17',
    COMPSCI: 1301,
    EECS: 1287,
    ECON: 1157.5,
    POLSCI: 840.5,
    UGBA: 682.5,
    MECENG: 593.5,
    SOCIOL: 528,
    PSYCH: 516,
    MEDIAST: 485.5,
    ENGLISH: 476.5,
    INTEGBI: null,
    ARCH: null,
    MATH: null,
    COGSCI: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2017-18',
    COMPSCI: 1545.5,
    EECS: 1373.5,
    ECON: 1242.5,
    POLSCI: 978.5,
    UGBA: 709.5,
    MECENG: 622.5,
    SOCIOL: 592.5,
    MEDIAST: 549.5,
    MATH: 545,
    COGSCI: 536.5,
    PSYCH: null,
    ENGLISH: null,
    INTEGBI: null,
    ARCH: null,
    CHMENG: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2018-19',
    COMPSCI: 1719,
    EECS: 1535.5,
    ECON: 1341,
    POLSCI: 1064.5,
    UGBA: 814,
    COGSCI: 685.5,
    MATH: 645,
    SOCIOL: 627.5,
    MECENG: 621,
    CHMENG: 515,
    MEDIAST: null,
    PSYCH: null,
    ENGLISH: null,
    INTEGBI: null,
    ARCH: null,
    DATA: null,
    MCELLBI: null,
  },
  {
    year: '2019-20',
    COMPSCI: 1834,
    EECS: 1586,
    ECON: 1362,
    POLSCI: 1048.5,
    UGBA: 903,
    DATA: 739,
    MECENG: 646.5,
    SOCIOL: 629,
    MATH: 628,
    CHMENG: 544.5,
    MEDIAST: null,
    PSYCH: null,
    ENGLISH: null,
    INTEGBI: null,
    ARCH: null,
    COGSCI: null,
    MCELLBI: null,
  },
  {
    year: '2020-21',
    COMPSCI: 1876.5,
    EECS: 1626.5,
    ECON: 1420,
    POLSCI: 1029,
    DATA: 1007,
    UGBA: 957,
    MCELLBI: 897,
    MECENG: 659.5,
    SOCIOL: 657,
    MATH: 540.5,
    CHMENG: null,
    MEDIAST: null,
    PSYCH: null,
    ENGLISH: null,
    INTEGBI: null,
    ARCH: null,
    COGSCI: null,
  },
  {
    year: '2021-22',
    COMPSCI: 2039,
    EECS: 1651,
    ECON: 1571,
    DATA: 1136,
    MCELLBI: 1081.5,
    UGBA: 1009,
    POLSCI: 976.5,
    MECENG: 763.5,
    PSYCH: 613.5,
    MATH: 600.5,
    CHMENG: null,
    MEDIAST: null,
    ENGLISH: null,
    INTEGBI: null,
    ARCH: null,
    COGSCI: null,
    SOCIOL: null,
  },
];

export default STEMEnrollmentData;
